import * as XLSX from 'xlsx';
import { transferSelectedDataToJson } from '../utils/utils';

const START_LINE = 1; // 从第2行开始读数据（0 ~ 1）

export function handleExcel(fileList, translate) {
  return new Promise((resolve, reject) => {
    let PromiseList = [];
    fileList.forEach((file) => {
      PromiseList.push(handelFile(file.originFileObj, translate));
    });

    Promise.all(PromiseList).then(
      (resdata) => {
        resolve(resdata);
      },
      (error) => {
        reject(error);
      },
    );
  });
}

function ifValidFile(verify) {
  if (verify === undefined) {
    return false;
  }
  if (verify.Type === '类型' || verify.Type === 'Type') {
    return true;
  }
  return false;
}

function handelFile(file, translate) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    // 读取excel的配置项 可能需要提供定制部分参数的接口
    const ExcelOption = {
      header: ['Type', 'Name', 'Account', 'PhoneNum', 'CorpUserId', 'Email'], // 输出数据格式 如果不指定该值，则以range指定的那一行作为关键字
      range: START_LINE, // 从第3行开始读数据（0 ~ 2）
      defval: '',
      blankrows: false, // 不包含空格行
    };

    fileReader.onload = (e) => {
      try {
        const { result } = e.target;
        const workbook = XLSX.read(result, { type: 'binary' });
        let data = [];
        for (const sheet in workbook.Sheets) {
          if (workbook.Sheets[sheet] !== undefined) {
            let tmpExcelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], ExcelOption);
            let verify = tmpExcelData.shift(); // 去除表头行，验证是否是符合要求的模板格式
            if (ifValidFile(verify) && tmpExcelData.length !== 0) {
              data = data.concat(tmpExcelData);
            } else if (tmpExcelData.length !== 0) {
              reject(translate('FileNotMeetRequire'));
            } else {
              reject(translate('EmptyFileExists'));
            }
          }
        }
        resolve(data);
      } catch (e) {
        reject(translate('FileTypeError'));
      }
    };
    fileReader.readAsBinaryString(file);
  });
}

export function injectFile(file, selectedList) {
  const fileReader = new FileReader();

  // 读取excel的配置项 可能需要提供定制部分参数的接口
  const ExcelOption = {
    header: ['Type', 'Name', 'Account', 'PhoneNum'],
    skipHeader: true,
    origin: 2,
  };

  fileReader.onload = (e) => {
    try {
      const { result } = e.target;
      const workbook = XLSX.read(result, { type: 'binary' });
      let data = transferSelectedDataToJson(selectedList);
      for (const sheet in workbook.Sheets) {
        if (workbook.Sheets[sheet] !== undefined) {
          XLSX.utils.sheet_add_json(workbook.Sheets[sheet], data, ExcelOption);
        }
      }
      XLSX.writeFile(workbook, 'excel.xlsx');
    } catch (e) {
      throw e;
    }
  };
  fileReader.readAsBinaryString(file);
}

export function writeJsonIntoFile(selectedList) {
  let jsonData = transferSelectedDataToJson(selectedList);
  let book = XLSX.utils.book_new();

  let sheet = XLSX.utils.json_to_sheet(
    [{ Type: '类型', Name: '名称', Account: 'ID', PhoneNum: '手机号' }, ...jsonData],
    {
      header: ['Type', 'Name', 'Account', 'PhoneNum'],
      skipHeader: true,
    },
  );
  XLSX.utils.book_append_sheet(book, sheet, 'Sheet1');
  XLSX.writeFile(book, 'excel.xlsx');
}
